var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.34.587H4.41C3.63.587 3 1.226 3 2.014v13.562c0 .684.475 1.255 1.11 1.395.006.017.005.03-.004.032l5.688 1.584c.778 0 1.41-.64 1.41-1.427v-.157h3.136c.779 0 1.41-.639 1.41-1.427V2.014c0-.788-.631-1.427-1.41-1.427zM9 9.973c0-.386 0-.761.75-.761s.75.384.75.761c0 .364 0 .739-.75.739S9 10.337 9 9.973zm5.293 4.9c0 .36-.29.654-.647.654h-2.443V3.597c0-.788-.305-1.117-1.41-1.426l-.473-.143s3.631.034 4.326.034c.694 0 .646.655.646.655v12.156z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5a2b9025d203c98b8a91de90ff1406f3.svg";
export { ForwardRef as ReactComponent };